(function () {
    'use strict';

    angular
        .module('app')
        .controller('SegmentsController', SegmentsController);

    SegmentsController.$inject = ['$state',];

    function SegmentsController($state) {
        // var vm = this;


        activate();

        function activate() {
            // Run on load
            if ($state && $state.current && $state.current.name === 'segments') {
                $state.go('segments.list');
            }
        }
    }
})();